import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";
import { useConfig } from "../../context/ConfigContext";

export default function SignIn() {
  const { nomeApp } = useConfig();
  return (
    <>
      <PageMeta title={`Entrar | ${nomeApp}`} description="Painel de acompanhamento de campanha eleitoral" />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
